import React from 'react'
import AboutContent from '../components/AboutContent/AboutContent';
import CustomHeroImage from './../components/CustomHeroImage/CustomHeroImage';

function About() {
  return (
    <div>
      <CustomHeroImage 
      heading="ABOUT"
      text="I am a Full stack web developer proficient in MERN stack "
      />
      <AboutContent />
    </div>
  )
}

export default About